import React from 'react';
import { Info } from 'lucide-react';

const AppVersion: React.FC = () => {
  return (
    <div className="fixed bottom-4 right-4 text-gray-500 text-xs flex items-center">
      <Info className="h-3 w-3 mr-1" />
      <span>v{import.meta.env.VITE_APP_VERSION || '0.1.0'}</span>
    </div>
  );
};

export default AppVersion;